<script lang="ts">
  import { defineComponent } from "vue";
  import SectionDemandeAttestationAbstract from '@/generated/sections/SectionDemandeAttestationAbstract.vue';
  export default defineComponent({
    extends: SectionDemandeAttestationAbstract,
    components: {}
  })
</script>
